import React, { Component, PropTypes, cloneElement } from 'react';
import { connect } from 'react-redux';
import { Paper, CircularProgress, FontIcon, Divider, IconMenu, MenuItem, IconButton } from 'material-ui';
import R from 'ramda';
import { getContractFolders as getContractFoldersAction } from '../../../../stores/contracting/contract-list/contract-list-actions';
import { openUpgradeFrom } from '../../../../stores/ui/components/upgrade/upgrade-actions';
import FieldAndSaveButton from './folder-field-save-button';
import LockIcon from 'material-ui/svg-icons/action/lock';
import OutBoxIcon from 'material-ui/svg-icons/content/unarchive';
import RCICon from 'material-ui/svg-icons/editor/highlight';
import ErrorIcon from 'material-ui/svg-icons/alert/error-outline';
import SentIcon from 'material-ui/svg-icons/content/send';
import ArchivedIcon from 'material-ui/svg-icons/content/archive';
import AddCircleOutlineIcon from 'material-ui/svg-icons/content/add-circle-outline';
import AllContractsIcon from 'material-ui/svg-icons/content/select-all';
import WallWrapper from '../../../wall/wrapper';

const propTypes = {
  getContractFolders: PropTypes.func,
  changeRoute: PropTypes.func,
  folderLoading: PropTypes.bool,
  folders: PropTypes.array,
  className: PropTypes.string,
  routeName: PropTypes.string,
  companyType: PropTypes.string,
  newFolderName: PropTypes.string,
  newFolderErrorText: PropTypes.string,
  renameFolderError: PropTypes.string,
  folderToBeRenamedIndex: PropTypes.number,
  outBoxCount: PropTypes.number,
  bouncedCount: PropTypes.number,
  rcCount: PropTypes.number,
  originalFolder: PropTypes.string,
  updateProps: PropTypes.func,
  deleteFolder: PropTypes.func,
  saveNewFolder: PropTypes.func,
  updateFolders: PropTypes.func,
  isBasicUser: PropTypes.bool,
  userId: PropTypes.string,
  openUpgradeFrom: PropTypes.func,
  createNewFolder: PropTypes.bool,
};
class ContractListLeftNav extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { getContractFolders } = this.props;
    getContractFolders();
  }
  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps));
  }
  renderDefaultMenuItems = (icon, primaryText, queryParam) => {
    const { changeRoute, routeName } = this.props;
    const isActive = routeName.toLowerCase() === queryParam.toLowerCase();
    return (
      <div
        key={primaryText}
        className={`contracting-left-nav-widget-link ${primaryText.toLowerCase().replace(' ', '-')} ${isActive ? 'is-active' : ''}`}
        style={{ color: isActive ? '#00bcd4' : 'white', fontSize: '14px', display: 'flex', alignItem: 'center' }}
        onClick={() => changeRoute(queryParam)}
      >
        {
          R.is(String, icon) ? (
            <FontIcon
              className={icon}
              color={isActive ? '#00bcd4' : 'white'}
              style={{ width: '36px' }}
            />
          ) : cloneElement(icon, { color: isActive ? '#00bcd4' : 'white', style: { width: '36px' } })
        }
        <span style={{ lineHeight: '24px', width: '70%' }}>
          {primaryText}
        </span>
      </div>
    );
  };
  renderMenuItem = R.curry((icon, folderName, index) => {
    const { changeRoute, folderToBeRenamedIndex, routeName, folders, updateProps, updateFolders, deleteFolder, renameFolderError, originalFolder } = this.props;
    const isActive = routeName.toLowerCase() === folderName.toLowerCase();
    if (folderToBeRenamedIndex === index) {
      return (
        <FieldAndSaveButton
          key={index}
          errorText={renameFolderError}
          value={folderName}
          onChange={({ target: { value } }) => updateProps({ folders: R.update(folderToBeRenamedIndex, value, folders), renameFolderError: undefined })}
          label="save"
          onTouchTap={() => {
            if (R.contains(folderName, R.remove(folderToBeRenamedIndex, 1, folders))) updateProps({ renameFolderError: 'Duplicate folder' });
            else updateFolders({ folders, originalFolder, newFolderName: folders[folderToBeRenamedIndex] });
          }}
          cancelFn={() => updateProps({ folders: R.update(folderToBeRenamedIndex, originalFolder, folders), folderToBeRenamedIndex: undefined, renameFolderError: undefined, originalFolder: undefined })}
        />
      );
    }
    return (
      <div
        key={index}
        data-cy={folderName}
        className={`contracting-left-nav-widget-link ${isActive ? 'is-active' : ''}`}
        style={{ color: isActive ? '#00bcd4' : 'white', fontSize: '12px', display: 'flex', alignItem: 'center' }}
      >
        <FontIcon
          className={icon}
          color={isActive ? '#00bcd4' : 'white'}
          style={{ width: '36px' }}
          onClick={() => changeRoute(folderName, true)}
        />
        <span style={{ lineHeight: '24px', width: '70%' }} onClick={() => changeRoute(folderName, true)}>{folderName}</span>
        <IconMenu
          iconButtonElement={<IconButton iconClassName="tc-icon-more_vert" iconStyle={{ color: 'white' }} style={{ height: '30px', padding: '0' }} />}
          style={{ display: isNaN(folderToBeRenamedIndex) ? 'inline-block' : 'none' }}
        >
          <MenuItem
            primaryText="Rename"
            leftIcon={<FontIcon className="tc-icon-mode_edit" color="#00bcd4" />}
            onTouchTap={() => updateProps({ folderToBeRenamedIndex: index, originalFolder: folderName })}
          />
          <MenuItem
            primaryText="Delete Folder"
            leftIcon={<FontIcon className="tc-icon-delete2" color="#ff4081" />}
            onTouchTap={() => {
              const confirmed = window.confirm('Are you sure you want to delete this folder? Please note that all files inside this folder will NOT be removed.');
              if (confirmed) {
                deleteFolder(folderName);
                if (routeName === folderName) changeRoute('all contracts');
              }
            }}
          />
        </IconMenu>
      </div>
    );
  });
  render() {
    const { folderLoading, folders, className, companyType, newFolderName, routeName, updateProps, saveNewFolder, newFolderErrorText, createNewFolder } = this.props;
    const defaultFolders = companyType === 'Contractor' ? [{
      primaryText: 'Received Rates',
      queryParam: 'recent',
      icon: 'tc-icon-inbox',
    }, {
      primaryText: 'Requests Sent',
      queryParam: 'sent',
      icon: <SentIcon/>,
    }] : [{
      primaryText: 'Requests',
      queryParam: 'recent',
      icon: 'tc-icon-inbox',
    }, {
      primaryText: 'Rates Sent',
      queryParam: 'sent',
      icon: <SentIcon/>,
    }];
    return (
      <Paper className={`${className || ''} contracting-left-nav-widget`} style={{ backgroundColor: '#383E4B', flex: '1' }} zDepth={2}>
        {
          defaultFolders.map(folder => this.renderDefaultMenuItems(folder.icon, folder.primaryText, folder.queryParam))
        }
        {
          Boolean(this.props.bouncedCount) && (
            <div
              className={`contracting-left-nav-widget-link ${routeName.toLowerCase() === 'outbox' ? 'is-active' : ''}`}
              style={{ color: routeName.toLowerCase() === 'outbox' ? '#00bcd4' : 'white', fontSize: '14px', display: 'flex', alignItem: 'center', overflow: 'visible' }}
              onClick={() => this.props.changeRoute('outBox')}
            >
              <div
                style={{ width: '36px' }}
              >
                {
                  this.props.isBasicUser ? <LockIcon style={{ color: '#FFD700' }} /> : <OutBoxIcon style={{ color: routeName.toLowerCase() === 'outbox' ? '#00bcd4' : 'white' }}/>
                }
              </div>
              <span
                style={{ lineHeight: '24px', width: '77%', display: 'flex', justifyContent: 'space-between' }}
                aria-label={this.props.isBasicUser ? `Upgrade to see which ${companyType === 'Supplier' ? 'contracts' : 'requests'} were bounced.` : ''}
                className={this.props.isBasicUser ? 'hint--top' : ''}
              >
                <span>Outbox</span>
                <ErrorIcon style={{ color: '#f44336' }}/>
              </span>
            </div>
          )
        }
        {this.renderDefaultMenuItems(<AllContractsIcon/>, 'All Contracts', 'all contracts')}
        {this.renderDefaultMenuItems(<ArchivedIcon/>, 'Archived', 'archived')}
        {this.renderDefaultMenuItems('tc-icon-delete2', 'Trash', 'trash')}
        {
          Boolean(this.props.rcCount) && <Divider style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }} />
        }
        {
          Boolean(this.props.rcCount) && (
            <div
              className={`contracting-left-nav-widget-link ${routeName.toLowerCase() === 'rate-conversion' ? 'is-active' : ''}`}
              style={{ color: routeName.toLowerCase() === 'rate-conversion' ? '#00bcd4' : 'white', fontSize: '14px', display: 'flex', alignItem: 'center', overflow: 'visible' }}
              onClick={() => this.props.changeRoute('rate-conversion')}
            >
              <div
                style={{ width: '36px' }}
              >
                <RCICon style={{ color: routeName.toLowerCase() === 'rate-conversion' ? '#00bcd4' : 'white' }}/>
              </div>
              <span
                style={{ lineHeight: '24px', width: '77%', display: 'flex', justifyContent: 'space-between' }}
              >
                <span>Rate Conversions</span>
              </span>
            </div>
          )
        }
        <Divider style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }} />
        <WallWrapper amazonOrange skipClick>
          <div className="flex-tc-sb" style={{ padding: '0 16px' }}>
            <div style={{ color: 'white' }}>Folders</div>
            <IconButton
              style={{ paddingRight: '6px' }}
              iconStyle={{ color: '#f1ebeb' }}
              onTouchTap={() => updateProps({ createNewFolder: true })}
            >
              <AddCircleOutlineIcon/>
            </IconButton>
          </div>
        </WallWrapper>
        {
          createNewFolder ? (
            <FieldAndSaveButton
              id="new folder"
              hintText="New Folder"
              errorText={newFolderErrorText}
              value={newFolderName || ''}
              onChange={(_, val) => updateProps({ newFolderName: val, newFolderErrorText: '' })}
              label="Save"
              onTouchTap={() => {
                if (R.contains(newFolderName, folders)) updateProps({ newFolderErrorText: 'Folder Exists' });
                else saveNewFolder(newFolderName);
              }}
              cancelFn={() => updateProps({ newFolderName: '', newFolderErrorText: '', createNewFolder: false })}
            />
          ) : <span/>
        }
        {
          folderLoading ? <CircularProgress size={40} style={{ marginLeft: '40%' }} /> : folders.map(this.renderMenuItem('tc-icon-folder_open'))
        }
      </Paper>
    );
  }
}
ContractListLeftNav.propTypes = propTypes;

const mapStateToProps = ({ contracting, user }) => ({
  folders: contracting.contractList.get('folders').toJS(),
  outBoxCount: contracting.contractList.get('outBoxCount'),
  bouncedCount: contracting.contractList.get('bouncedCount'),
  rcCount: contracting.contractList.get('rcCount'),
  newFolderName: contracting.contractList.get('newFolderName'),
  newFolderErrorText: contracting.contractList.get('newFolderErrorText'),
  renameFolderError: contracting.contractList.get('renameFolderError'),
  originalFolder: contracting.contractList.get('originalFolder'),
  folderToBeRenamedIndex: contracting.contractList.get('folderToBeRenamedIndex'),
  folderLoading: contracting.contractList.get('folderLoading'),
  createNewFolder: contracting.contractList.get('createNewFolder'),
  companyType: user.getIn(['user', 'type']),
  userId: user.get('id'),
  isBasicUser: user.get('billingPlan') === 'basic',
});

export default connect(mapStateToProps, { openUpgradeFrom, getContractFolders: getContractFoldersAction })(ContractListLeftNav);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/left-nav/left-nav.jsx